module.exports = __webpack_public_path__ + "static/media/rectangle.a3b01df5.svg";